<ng-container *ngIf="remoteFormData">
    <ubs-ofbiz-list 
        [listOptions]="listOptions" 
        [columnFields]="columnFields"
        [remoteFormData]="remoteFormData"
        [fieldOptions]="fieldOptions"
        [isLookup]="isLookup"
        (rowSelected)="onRowSelected($event)">
    </ubs-ofbiz-list>
</ng-container>


